import * as React from 'react';
import { Redirect } from 'react-router';

import GetUserQuery from './components/Query/Users';
import AppLayout from './components/Layout/AppLayout';

import './styles/main.scss';

class App extends React.Component {
  render() {
    return (
      <GetUserQuery>
        {({ loggedIn }: any) => {
          // zjištění přihlášení
          if (loggedIn && !loggedIn.loading && loggedIn.loggedIn) {
            // přihlášen
            if (loggedIn.loggedIn.logged === true) {
              return <AppLayout />;
            }

            localStorage.removeItem('token');
            localStorage.removeItem('user');
            return <Redirect to={'/'} />;
          }

          return null;
        }}
      </GetUserQuery>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx